import * as React from "react";

function SvgSalesmachine(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#FFF" y={0.375} width={96.07} height={95.628} rx={19.051} />
        <path
          d="M0 19.428C0 8.905 8.535.375 19.053.375h56.894C86.47.375 95 8.91 95 19.428v56.894c0 10.523-8.535 19.053-19.053 19.053H19.053C8.53 95.375 0 86.84 0 76.322V19.428zm8.485.273c0-6.009 4.882-10.88 10.88-10.88h57.239c6.009 0 10.88 4.882 10.88 10.88V76.94c0 6.009-4.882 10.88-10.88 10.88H19.366c-6.01 0-10.881-4.882-10.881-10.88V19.7z"
          fill="#4E6288"
        />
        <path
          d="M68.698 14.542h7.69a5.445 5.445 0 015.447 5.45v56.392c0 3.01-2.446 5.45-5.446 5.45h-56.71a5.445 5.445 0 01-5.447-5.45v-7.628c30.08 0 54.466-24.272 54.466-54.214z"
          fill="#4485D1"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSalesmachine);
